<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: '150',
      require: true,
    },
  },
}
</script>

<template>
  <v-img
    :src="require('@assets/images/idoors_logo_blue.png')"
    contain
    :width="width"
    aspect-ratio="2.5"
  />
</template>
